import React from 'react';
import InfoTooltip from '@ui/tooltip/InfoTooltip';

const MarketSimulationInfo: React.FunctionComponent = () =>
	<InfoTooltip label="About Recommendation Price" title="Market simulation">
		This is a simulation of your market price after the recommended change, for comparison with competitors. The drawer shows the proposed WebHotelier room rates.
	</InfoTooltip>;

export default MarketSimulationInfo;
